import { fetchWithHeaders, parseResponse } from '../helpers/utils'

export const clearCache = (key) => {
  return fetchWithHeaders(`v1/songs/cache${key ? `?recordMatch=${key}` : ''}`, {
    method: 'DELETE',
  }).then(parseResponse)
}
